<template>
    <div class="chongzhijilu">
        <span class="msg">
            温馨提示:若充值成功, 缩币未及时到账,请及时联系客服
        </span>
        <div class="title">
            <span>缩币充值</span>
            <div>
                <div>当前充值 {{statistics.money}} <span>元</span></div>
                <div>收益缩币 {{statistics.virtualCoin}} <span>个</span></div>
                <div>消费缩币 {{statistics.consumptionCoin}} <span>个</span></div>
                <div>缩币余额 {{statistics.residueCoin}} <span>个</span></div>
                <div>未付款订单 {{statistics.unpaidOrder}} <span>个</span></div>
            </div>
        </div>
        <el-table
			v-loading="tableLoading"
            :data="tableData"
            border
			style="width: 100%"
            :header-cell-style="{ color: '#ffffff', backgroundColor: '#2899DF', }"
        >
            <el-table-column prop="orderNo" label="充值单号" />
            <el-table-column prop="payType" label="充值方式" >
                <template slot-scope="scope">
                    {{ scope.row.payType | handlePretype(preType) }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="money" label="金额（RBM）" /> -->
            <el-table-column prop="virtualcoin" label="缩币" />
            <el-table-column prop="createTime" label="充值时间" />
            <el-table-column prop="updateTime" label="缩币到账时间" />
            <el-table-column prop="status" label="充值状态" >
				<template slot-scope="scope">
					{{scope.row.status.displayName}}
				</template>
			</el-table-column>
        </el-table>

        <el-pagination v-if="listPagin.total > 9"
						style="padding-top:20px;text-align:right"
						background
                       	layout="prev, pager, next"
                       	@current-change="changePage"
					   	:page-size="listPagin.limit"
                       	:total="listPagin.total">
        </el-pagination>
    </div>
</template>

<script>
import {count,record,} from '@/api/chongzhi';
import {queryDictionary} from "@/api/common"
export default {
    data() {
        return {
            preType:[],
            
            tableData: [],		//充值记录
			statistics:{},		//充值统计

			tableLoading:false,

			listPagin:{
				page:1,
				limit:10,
				total:0
			},

        };
    },
    filters:{
        handlePretype(val,preType){
            return preType.filter(item=>item.dictValue == val)[0].dictLabel
        }
    },
    mounted(){
		// 充值统计
		count().then(res=>this.statistics = res.data)
		
        queryDictionary('pre_pay_type').then(res=>{
            this.preType = JSON.parse(JSON.stringify(res.data,['dictLabel','dictValue']))
            this.getList()
        })

    },
    methods:{

		getList(){
			// 充值记录
			record({
				pageNum:this.listPagin.page,
				pageSize:this.listPagin.limit,
			}).then(res=>{
                console.log(res);
				this.tableLoading = false
				let {total,rows} = res.data
				this.tableData = rows
				this.listPagin.total = total
			})
		},

		// 分页状态变化
        changePage (e) {
			this.tableLoading = true
			this.listPagin.page = e
            this.getList();
        },
    }
};
</script>

<style lang="scss" scoped>
.chongzhijilu{
    .msg{
        display: inline-block;
        padding: 10px 30px;
        background-color: #F4CE98;
        font-size: 14px;
        margin-bottom: 20px;
    }
    .title{
        display: flex;
        align-items: center;
        border-bottom: 2px solid #2899DF;
        margin-bottom: 20px;
        >span{
            background-color: #2899DF;
            padding: 10px 30px;
            display: inline-block;
            margin-right: 50px;
        }
        >div{
            display: flex;
            //border: 2px solid rgba(40, 153, 223,.5);
            padding: 7px;
            position: relative;
            top: 3px;
            font-size: 14px;
            span{
                color: red;
                margin-right: 10px;
            }
            >div{
                border-right: 2px solid #dadada;
                margin-right: 10px;
                &:last-child{
                    margin-right: 0;
                    border-right: none;
                }
            }
        }
    }

}
.pagination{
    margin: 20px 0;
    display: flex;
    justify-content: center;
}
</style>
